import { post } from '@/api/api'

export const actions = {
  fetchNpiInfo({ commit }, npi){
    return post(`/citizenship-info?identifier=${npi}&token=sica-111111-1111222-0000-1111`)
    .then(({ data }) =>{
      return data
    })
  },
}